export const FirebaseConfig = {
	"projectId": "tripna2025-fa879",
	"appId": "1:982911320825:web:ff73a73786aa4792b99828",
	"databaseURL": "https://tripna2025-fa879-default-rtdb.firebaseio.com",
	"storageBucket": "tripna2025-fa879.firebasestorage.app",
	"apiKey": "AIzaSyDgk1XMtLZRERAmeHU8eeFJRYrSOzV5F04",
	"authDomain": "tripna2025-fa879.firebaseapp.com",
	"messagingSenderId": "982911320825",
	"measurementId": "G-1TWN5G7FJD"
};